<div class="content">
  <div></div>
  <ag-grid-angular
    #grid
    [gridOptions]="gridOptions"
    [rowData]="gridRows"
    (gridReady)="onGridReady()"
    suppressMenuHide
    style="width: 100%; height: 100%;"
    class="ag-theme-balham"
  >
    <ag-grid-column
      [headerName]="'アカウントID'"
      [field]="'accountId'"
      [width]="130"
      [filter]="'text'"
    >
    </ag-grid-column>
    <ag-grid-column
      [headerName]="'アカウント名'"
      [field]="'name'"
      [width]="150"
      [filter]="'text'"
    >
    </ag-grid-column>
    <ag-grid-column
      [headerName]="'カテゴリ'"
      [field]="'category'"
      [width]="130"
      [filter]="'text'"
    >
    </ag-grid-column>
    <ag-grid-column
      [headerName]="'スコア1'"
      [field]="'score1'"
      [width]="130"
      [filter]="'number'"
    >
    </ag-grid-column>
    <ag-grid-column
      [headerName]="'スコア2'"
      [field]="'score2'"
      [width]="130"
      [filter]="'number'"
    >
    </ag-grid-column>
    <ag-grid-column
      [headerName]="'レート'"
      [field]="'rate'"
      [width]="130"
      [filter]="'number'"
    >
    </ag-grid-column>
  </ag-grid-angular>
</div>
